module.exports = "/reports/components/reportsTableComponent-56cab3.html";